{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Lataa (v2)"
      }
    }
  },
  "promotion": {
    "checkedInBaggage": {
      "genericBaggageType": "Matkatavara",
      "numberedBaggageTitle": "{bagNumber}. {baggageType}",
      "baggageWeight": "{weight} kg"
    }
  },
  "includedProducts": {
    "quotaLeft": {
      "singular": "Vain yksi jäljellä",
      "plural": "Vain {quota} jäljellä"
    }
  }
}
